import { createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "portfolio-modal" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", { class: "for-mobile icon-cross3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["mainOverlay", { online: _ctx.isModalVisible() }],
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeModal()))
    }, null, 2),
    _createVNode("span", {
      class: ["close-pop", { online: _ctx.isModalVisible() }],
      id: "close-pop",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (this.closeModal()))
    }, [
      _hoisted_2
    ], 2),
    _createVNode("div", {
      class: ["portfolioPop", { online: _ctx.isModalVisible() }],
      id: "base-modal"
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}